import { createSlice } from '@reduxjs/toolkit'

import { copyDeep } from '_src/utils'

const from = {
  type: 1,
  symbol: 'AAC',
  contract_addr: '',
  balance: 100,
  input: 0,
}

const to = {
  type: 2,
  symbol: 'WAAC',
  contract_addr: '',
  balance: 0,
}

// state数据
let initialState = {
  visible: false,
  networkId: '',
  from: {
    ...from,
  },
  to: {
    ...to,
  },
}

export const swapSlice = createSlice({
  name: 'swap',
  initialState,
  reducers: {
    setSwapVisible: (state, { payload }) => {
      if (!payload) {
        state.from = copyDeep(from)
        state.to = copyDeep(to)
      }

      state.visible = payload
    },

    setSwapNetworkId: (state, action) => {
      state.networkId = action.payload
    },
    setFromData: (state, action) => {
      state.from = { ...state.from, ...action.payload }
    },
    setToData: (state, action) => {
      state.to = { ...state.to, ...action.payload }
    },
    setFromInput: (state, action) => {
      state.from = {
        ...state.from,
        input: String(action.payload),
      }
    },
    setConvert: (state) => {
      const from = copyDeep(state.from)
      const to = copyDeep(state.to)

      let input = state.from.input
      if (to.balance < input) {
        input = to.balance
      }

      state.from = {
        ...state.from,
        input: String(input),
        symbol: to.symbol,
        contract_addr: to.contract_addr,
        balance: to.balance,
      }

      state.to = {
        ...state.to,
        symbol: from.symbol,
        contract_addr: from.contract_addr,
        balance: from.balance,
      }
    },
  },
})

export const { setSwapVisible, setSwapNetworkId, setFromData, setToData, setFromInput, setConvert } = swapSlice.actions

export default swapSlice.reducer
